import dynamic from 'next/dynamic';

import type { SectionTitleSectionProps } from '../../../components/sections/SectionTitleSection';
import type { SectionRenderer } from '../../../types/Section';
import type { Transformer } from '../../../types/Transformer';
import type { SectionTitleContentSection } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<SectionTitleSectionProps> =
  dynamic<SectionTitleSectionProps>(() =>
    import('../../../components/sections/SectionTitleSection').then(
      (mod) => mod.SectionTitleSection,
    ),
  );

export const transformer: Transformer<SectionTitleContentSection, SectionTitleSectionProps> = (
  { title, _metadata },
  { pageConfig, positionMetadata },
) => ({
  uid: _metadata.uid,
  props: {
    title,
    headingIsPageTitle: positionMetadata.position === 0 && pageConfig.pageType !== 'homepage',
  },
});
